import { getToken, messaging, onMessage } from "../firebase";
import { NOTIFICATION_PERMISSION } from "utils/helpers/enums/shared.enum";
import { DeviceTokenDTO } from "utils/helpers/models/auth/device-token.dto";
import { Auth_APIS } from "libs/apis/auth.api";
import { useState } from "react";

const useFirebase = () => {
  const generateUUID = () => {
    // Check if crypto API is available
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }

    // Fallback for browsers that don't support crypto.randomUUID
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const getOrCreateDeviceId = () => {
    const STORAGE_KEY = "app_device_id";
    let deviceId = localStorage.getItem(STORAGE_KEY);

    if (!deviceId) {
      deviceId = generateUUID();
      localStorage.setItem(STORAGE_KEY, deviceId);
    }

    return deviceId;
  };
  let unsubscribeListener = null;

  const storeDeviceToken = async (body: DeviceTokenDTO) => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }
    try {
      const response = await Auth_APIS.storeDeviceToken(body);
      const { status = false } = response || {};
    } catch (error) {
      console.log("Device token storage failed:", error);
    }
  };

  const getNotificationPermission = async () => {
    const permission = await Notification.requestPermission();
    if (permission === NOTIFICATION_PERMISSION.GRANTED) {
      getFCMToken();
    }
  };

  const getFCMToken = async () => {
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });
    const deviceId = getOrCreateDeviceId();
    if (token) {
      const body = new DeviceTokenDTO({ token, deviceId });
      storeDeviceToken(body);
    }
  };

  const registerServiceWorker = async () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then(() => {})
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    }
  };

  const onMessageListener = (eventId: number, setMessages: Function) => {
    unsubscribeListener = onMessage(messaging, (payload) => {
      console.log(payload, "messaging");
      console.log("Foreground message received:", payload);
    });
  };

  const unSubscribeMsgListener = () => {
    if (unsubscribeListener) {
      unsubscribeListener();
    }
  };

  return {
    getNotificationPermission,
    registerServiceWorker,
    onMessageListener,
    unSubscribeMsgListener,
  };
};

export default useFirebase;
